import { useRef } from "react"

export const useTimeOut = () => {
    const addTime = useRef<NodeJS.Timeout>()

    const executeFunction = ({ time = 300, execute }: { time?: number; execute: () => void }) => {
        if (addTime.current) { clearTimeout(addTime.current) }
        addTime.current = setTimeout(() => {
            execute()
        }, time)
    }
    return { executeFunction }
}